import { useState, FormEvent } from 'react';

const ReservationSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    furigana: '',
    phone: '',
    email: '',
    menu: '',
    datetime: '',
    message: '',
    agree: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const menus = [
    '痩身・ボディメイク（Fit Carving）',
    'フェイシャル（Revcella）',
    '頭皮ケア＆育毛（MOUMITU）',
    'LED光トリートメント（WellTerra）',
    'トータルケアプラン',
    'その他・相談したい',
  ];

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!formData.agree) {
      alert('プライバシーポリシーに同意してください');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('furigana', formData.furigana);
      formBody.append('phone', formData.phone);
      formBody.append('email', formData.email);
      formBody.append('menu', formData.menu);
      formBody.append('datetime', formData.datetime);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d4p9b11fcjnktac9qhag', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          furigana: '',
          phone: '',
          email: '',
          menu: '',
          datetime: '',
          message: '',
          agree: false,
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="reservation" className="py-16 md:py-24 bg-beige px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-dark-gray mb-4">
            ご予約
          </h2>
          <p className="text-sm md:text-base text-medium-gray">
            お電話またはWEBフォームからご予約いただけます
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-12">
          <a
            href="#reservation-form"
            className="bg-gold text-white px-8 py-6 rounded-2xl text-lg font-semibold hover:bg-gold/90 transition-colors text-center flex items-center justify-center gap-3 whitespace-nowrap"
          >
            <i className="ri-calendar-check-line w-6 h-6 flex items-center justify-center text-2xl"></i>
            <span>WEBで予約</span>
          </a>
          <a
            href="tel:08091541191"
            className="bg-white text-gold border-2 border-gold px-8 py-6 rounded-2xl text-lg font-semibold hover:bg-light-gold transition-colors text-center flex items-center justify-center gap-3 whitespace-nowrap"
          >
            <i className="ri-phone-fill w-6 h-6 flex items-center justify-center text-2xl"></i>
            <span>電話で予約</span>
          </a>
        </div>

        <form
          id="reservation-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="bg-white rounded-3xl p-6 md:p-10 shadow-lg"
        >
          <h3 className="text-xl md:text-2xl font-serif font-semibold text-dark-gray mb-8 text-center">
            WEB予約フォーム
          </h3>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                お名前 <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray"
                placeholder="山田 花子"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                フリガナ <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="furigana"
                required
                value={formData.furigana}
                onChange={(e) => setFormData({ ...formData, furigana: e.target.value })}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray"
                placeholder="ヤマダ ハナコ"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                電話番号 <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                required
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray"
                placeholder="090-1234-5678"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                メールアドレス <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray"
                placeholder="example@email.com"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                希望メニュー <span className="text-red-500">*</span>
              </label>
              <select
                name="menu"
                required
                value={formData.menu}
                onChange={(e) => setFormData({ ...formData, menu: e.target.value })}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray appearance-none cursor-pointer"
                style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23D4AF37'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 1rem center',
                  backgroundSize: '1.5rem',
                }}
              >
                <option value="">選択してください</option>
                {menus.map((menu, index) => (
                  <option key={index} value={menu}>
                    {menu}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                希望日時 <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="datetime"
                required
                value={formData.datetime}
                onChange={(e) => setFormData({ ...formData, datetime: e.target.value })}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray"
                placeholder="例：2025年2月15日 14:00〜"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-dark-gray mb-2">
                ご相談内容
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 rounded-lg bg-light-gold border-0 focus:outline-none focus:ring-2 focus:ring-gold text-dark-gray resize-none"
                placeholder="気になることやご質問などございましたらご記入ください（500文字以内）"
              ></textarea>
              <p className="text-xs text-medium-gray mt-1 text-right">
                {formData.message.length}/500文字
              </p>
            </div>

            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="agree"
                checked={formData.agree}
                onChange={(e) => setFormData({ ...formData, agree: e.target.checked })}
                className="mt-1 w-5 h-5 text-gold focus:ring-gold border-medium-gray rounded cursor-pointer"
              />
              <label htmlFor="agree" className="text-sm text-dark-gray cursor-pointer">
                <a href="/privacy" className="text-gold hover:underline">
                  プライバシーポリシー
                </a>
                に同意します
              </label>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                ご予約を受け付けました。確認のご連絡をお待ちください。
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                送信に失敗しました。お手数ですがお電話にてご連絡ください。
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-gold text-white py-4 rounded-full text-lg font-semibold hover:bg-gold/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isSubmitting ? '送信中...' : '予約を送信する'}
            </button>
          </div>
        </form>

        <div className="mt-12 bg-white rounded-3xl p-6 md:p-8 text-center">
          <h3 className="text-lg md:text-xl font-semibold text-dark-gray mb-4">
            LINEでも予約できます
          </h3>
          <p className="text-sm text-medium-gray mb-6">
            お気軽にご相談・ご予約いただけます
          </p>
          <a
            href="https://line.me/R/ti/p/@luciall"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#06C755] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#06C755]/90 transition-colors whitespace-nowrap"
          >
            <i className="ri-line-fill w-6 h-6 flex items-center justify-center text-2xl"></i>
            <span>友だち追加</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReservationSection;
